export const getEmptyPeriodicidade = () => ({
  id: null,
  periodicidade: null,
  desconto_boleto: 0,
  desconto_pix: 0,
  desconto_cc: 0,
  parcelas_credito: 1,
  is_default: false,
  status: true,
  valor_boleto: null,
  valor_pix: null,
  valor_cc: null,
});
